import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { C, F, maxW, trans } from "../tokens";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      backgroundColor: C.dark,
      color: "rgba(255,255,255,.72)",
      fontSize: ".84rem",
    }}
  >
    {/* CTA strip */}
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1.5rem", md: "2.5rem" },
        pt: { xs: "3.5rem", md: "2.5rem" },
        pb: { xs: "3.5rem", md: "4.5rem" },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr auto" },
        gap: "2rem",
        alignItems: "end",
        borderBottom: "1px solid rgba(255,255,255,.1)",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontFamily: F.display,
            fontSize: "clamp(2rem, 3.5vw, 3rem)",
            fontWeight: 300,
            color: "#fff",
            lineHeight: 1.2,
            "& em": { fontStyle: "italic", color: "rgba(255,255,255,.65)" },
          }}
        >
          Une question avant de venir ?<br />
          <em>Appelez-moi.</em>
        </Typography>
        <Typography
          sx={{
            fontSize: ".88rem",
            color: "rgba(255,255,255,.55)",
            mt: ".9rem",
            maxWidth: "380px",
            lineHeight: 1.7,
          }}
        >
          Si je suis en consultation, laissez un message ou un SMS je vous
          rappelle dans la journée.
        </Typography>
      </Box>

      <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
        <Box
          component="a"
          href="tel:0695788983"
          sx={{
            fontSize: "1.3rem",
            fontWeight: 600,
            color: "#fff",
            display: "block",
            mb: ".4rem",
            textDecoration: "none",
            "&:hover": { color: "#fff" },
          }}
        >
          06 95 78 89 83
        </Box>
        <Box
          component="a"
          href="mailto:nicolaieffmaxime@gmail.com"
          sx={{
            color: "rgba(255,255,255,.55)",
            fontSize: ".83rem",
            display: "block",
            mb: "1rem",
            textDecoration: "none",
            "&:hover": { color: "rgba(255,255,255,.8)" },
          }}
        >
          nicolaieffmaxime@gmail.com
        </Box>
        <Box
          component="a"
          href="mailto:nicolaieffmaxime@gmail.com"
          sx={{
            color: "rgba(255,255,255,.65)",
            fontSize: ".83rem",
            transition: `color ${trans}`,
            textDecoration: "none",
            "&:hover": { color: "#fff" },
            "&::after": { content: '" →"' },
          }}
        >
          Écrire un message
        </Box>
      </Box>
    </Box>

    {/* Columns */}
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1.5rem", md: "2.5rem" },
        py: { xs: "2.5rem", md: "3rem" },
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr 1fr",
          sm: "1fr 1fr",
          md: "repeat(3, 1fr)",
        },
        gap: { xs: "2rem", md: "2.5rem" },
        borderBottom: "1px solid rgba(255,255,255,.1)",
      }}
    >
      {[
        {
          title: "Cabinets",
          content: (
            <Box
              component="ul"
              sx={{ display: "flex", flexDirection: "column", gap: ".45rem" }}
            >
              <Box
                component="li"
                sx={{ color: "rgba(255,255,255,.6)", lineHeight: 1.5 }}
              >
                8 Route de Mons
                <br />
                31130 Balma
              </Box>
              <Box
                component="li"
                sx={{
                  color: "rgba(255,255,255,.6)",
                  lineHeight: 1.5,
                  mt: ".5rem",
                }}
              >
                164 All. du Camp del Rey
                <br />
                31620 Castelnau-d'Estrétefonds
              </Box>
            </Box>
          ),
        },
        {
          title: "Plan du site",
          content: (
            <Box
              component="ul"
              sx={{ display: "flex", flexDirection: "column", gap: ".45rem" }}
            >
              {[
                ["/votre-osteopathe", "À propos"],
                ["/pathologies", "Pathologies"],
                ["/pathologies/nourrissons", "Nourrissons"],
                ["/pathologies/femme-enceinte", "Femme enceinte"],
                ["/pathologies/drainage-lymphatique", "Drainage lymphatique"],
                ["/pathologies/sciatique", "Sciatique"],
                ["/pathologies/hernie-discale", "Hernie discale"],
                ["/pathologies/tendinite", "Tendinites"],
                ["/tarifs-et-remboursements", "Tarifs"],
                ["/faq", "FAQ"],
                ["/partenariats", "Partenariats"],
                ["/mentions-legales", "Mentions légales"],
              ].map(([to, label]) => (
                <Box key={to} component="li">
                  <Box
                    component={Link}
                    to={to}
                    sx={{
                      color: "rgba(255,255,255,.6)",
                      textDecoration: "none",
                      transition: `color ${trans}`,
                      "&:hover": { color: "#fff" },
                    }}
                  >
                    {label}
                  </Box>
                </Box>
              ))}
            </Box>
          ),
        },
        {
          title: "Prendre rendez-vous",
          content: (
            <Box
              component="ul"
              sx={{ display: "flex", flexDirection: "column", gap: ".45rem" }}
            >
              <Box component="li">
                <Box
                  component="a"
                  href="https://www.doctolib.fr/osteopathe/balma/maxime-nicolaieff"
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    color: "rgba(255,255,255,.6)",
                    textDecoration: "none",
                    transition: `color ${trans}`,
                    "&:hover": { color: "#fff" },
                  }}
                >
                  Réserver sur Doctolib
                </Box>
              </Box>
            </Box>
          ),
        },
      ].map(({ title, content }) => (
        <Box key={title}>
          <Typography
            sx={{
              fontSize: ".65rem",
              fontWeight: 600,
              letterSpacing: "2.5px",
              textTransform: "uppercase",
              color: "rgba(255,255,255,.4)",
              mb: "1rem",
            }}
          >
            {title}
          </Typography>
          {content}
        </Box>
      ))}
    </Box>

    {/* Bottom bar */}
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: { xs: "1.5rem", md: "2.5rem" },
        py: { xs: "1.25rem", md: "1.5rem" },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "center", md: "center" },
        gap: ".5rem",
        fontSize: ".75rem",
        color: "rgba(255,255,255,.3)",
        textAlign: { xs: "center", md: "left" },
      }}
    >
      <Box component="span">© 2026 Maxime Nicolaieff Ostéopathe D.O.</Box>
      <Box component="span">
        Diplômé du Conservatoire Supérieur d'Ostéopathie Toulouse 2019
      </Box>
      <Box component="span">
        Site réalisé par{" "}
        <Box
          component="a"
          href="https://www.linkedin.com/in/yvan-mackowiak/"
          target="_blank"
          rel="noreferrer"
          sx={{
            color: "rgba(255,255,255,.3)",
            textDecoration: "none",
            transition: `color ${trans}`,
            "&:hover": { color: "rgba(255,255,255,.6)" },
          }}
        >
          Yvan Mackowiak
        </Box>
      </Box>
    </Box>
  </Box>
);

export default Footer;
